import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-userpartner',
  templateUrl: './userpartner.component.html',
  styleUrls: ['./userpartner.component.css']
})
export class UserpartnerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
